import { AppEvent } from '@core/modules/event-bus/events/app-event';

export interface ThemeChangedPayload {
  theme: 'light' | 'dark' | 'auto';
}

/**
 * Theme Events
 */
export class ThemeChangedEvent extends AppEvent<ThemeChangedPayload> {
  readonly type = 'theme:changed' as const;

  constructor(payload: ThemeChangedPayload) {
    super(payload);
  }
}

export const ThemeEvents = {
  Changed: ThemeChangedEvent,
} as const;
